import http from './httpService'

/*** Get list of orders from shopify based on query ***/
export function getOrdersAmazon(page, store, query, limit) {
  limit = limit || 50

  let url = `/amazon/orders?limit=${limit}&store=${store}&page=${page}`

  if (query) url += `&query=${encodeURIComponent(query)}`

  return http.get(url)
}

/*** Renew order from shopify ***/
export function renewRegistryAmazon(orderId) {
  if (!orderId) return console.log('orderId is undefined')

  return http.get(`/webhooks/amazon/order-creation?Id=${orderId}`)
}

/*** Count number of orders based on status ***/


